import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { ArrowUpRightIcon } from 'lucide-react';
import React from 'react';

import { CommandGroup, CommandItem } from '../ui/command';

export const ExploreCategories: React.FC<{
  onSelect: (slug: string) => Promise<void>;
}> = ({ onSelect }) => {
  const { puffy, palo, zigzag, max, monster, bronto, alphabeta } =
    useStaticQuery(graphql`
      {
        puffy: contentfulProductVariant(sku: { eq: "20191" }) {
          thumbnailImage {
            gatsbyImageData(
              formats: [AUTO, AVIF, WEBP]
              quality: 80
              width: 32
              height: 32
              layout: FIXED
              placeholder: BLURRED
            )
          }
        }
        palo: contentfulProductVariant(sku: { eq: "20366" }) {
          thumbnailImage {
            gatsbyImageData(
              formats: [AUTO, AVIF, WEBP]
              quality: 80
              width: 32
              height: 32
              layout: FIXED
              placeholder: BLURRED
            )
          }
        }
        zigzag: contentfulProductVariant(sku: { eq: "20089" }) {
          thumbnailImage {
            gatsbyImageData(
              formats: [AUTO, AVIF, WEBP]
              quality: 80
              width: 32
              height: 32
              layout: FIXED
              placeholder: BLURRED
            )
          }
        }
        max: contentfulProductVariant(sku: { eq: "30600" }) {
          thumbnailImage {
            gatsbyImageData(
              formats: [AUTO, AVIF, WEBP]
              quality: 80
              width: 32
              height: 32
              layout: FIXED
              placeholder: BLURRED
            )
          }
        }
        monster: contentfulProductVariant(sku: { eq: "30805" }) {
          thumbnailImage {
            gatsbyImageData(
              formats: [AUTO, AVIF, WEBP]
              quality: 80
              width: 32
              height: 32
              layout: FIXED
              placeholder: BLURRED
            )
          }
        }
        bronto: contentfulProductVariant(sku: { eq: "30680" }) {
          thumbnailImage {
            gatsbyImageData(
              formats: [AUTO, AVIF, WEBP]
              quality: 80
              width: 32
              height: 32
              layout: FIXED
              placeholder: BLURRED
            )
          }
        }
        alphabeta: contentfulProductVariant(sku: { eq: "20056" }) {
          thumbnailImage {
            gatsbyImageData(
              formats: [AUTO, AVIF, WEBP]
              quality: 80
              width: 32
              height: 32
              layout: FIXED
              placeholder: BLURRED
            )
          }
        }
      }
    `);

  const categories = [
    {
      title: 'Chairs and stools',
      url: '/furniture/chairs-and-stools',
      image: puffy?.thumbnailImage?.gatsbyImageData,
    },
    {
      title: 'Sofas and poufs',
      url: '/furniture/sofas-and-poufs',
      image: palo?.thumbnailImage?.gatsbyImageData,
    },
    {
      title: 'Tables and side tables',
      url: '/furniture/tables-and-side-tables',
      image: max?.thumbnailImage?.gatsbyImageData,
    },
    {
      title: 'Shelving and storage',
      url: '/furniture/shelving-and-storage',
      image: zigzag?.thumbnailImage?.gatsbyImageData,
    },
    {
      title: 'Lighting',
      url: '/lighting',
      image: alphabeta?.thumbnailImage?.gatsbyImageData,
    },
    {
      title: 'Rugs',
      url: '/rugs',
      image: monster?.thumbnailImage?.gatsbyImageData,
    },
    {
      title: 'Accessories',
      url: '/accessories',
      image: bronto?.thumbnailImage?.gatsbyImageData,
    },
  ].filter((category) => category.image !== undefined);

  return (
    <CommandGroup heading="Explore" className="divide-y divide-black-100/75">
      <div className="divide-y divide-black-50">
        {categories.map((cat) => (
          <CommandItem
            key={cat.url}
            value={cat.title}
            onSelect={() => onSelect(cat.url)}
            className="group grid h-8 grid-cols-[auto,1fr,auto] gap-4 py-0 text-black-600 hover:cursor-pointer"
          >
            <GatsbyImage
              image={cat.image}
              alt={cat.title}
              className="h-8 w-8 rounded-sm mix-blend-multiply"
            />
            <div>{cat.title}</div>
            <ArrowUpRightIcon className="h-4 w-4 text-black-400 group-hover/recent:text-black-600" />
          </CommandItem>
        ))}
      </div>
    </CommandGroup>
  );
};
